import { createReducer } from '@reduxjs/toolkit';
import { AuditLogMessageAction, IModerationAuditLogState as State } from '../types';
import * as actions from '../actions';

const {
  fetchMessageAuditLogSuccess,
  resetAllFilters,
  fetchMessageAuditLogFailure,
  approveItemsSuccess,
  rejectItemsSuccess
} = actions;

const initialState: State = {
  auditLogs: {}
};

const auditReducer = createReducer(initialState, {
  [fetchMessageAuditLogSuccess.type]: (
    state,
    { payload: { messageId, timeline, isOnlyManual } }
  ) => {
    const updatedTimeline = timeline.map(({ currentState, published, action, ...rest }) => ({
      ...rest,
      currentState,
      action:
        rest.userId === 'system' && action === AuditLogMessageAction.CREATED
          ? AuditLogMessageAction.MODERATED
          : action,
      published: published && currentState === AuditLogMessageAction.PENDING
    }));
    // isManualOnly - fetching only the last manual action for the manual tag tooltip.
    const currentAuditLog = state.auditLogs[messageId];
    if (isOnlyManual) {
      const lastManualActionIndex = updatedTimeline.findIndex(o => o.action === 'moderated');
      state.auditLogs[messageId] = {
        ...currentAuditLog,
        tooltip: updatedTimeline[lastManualActionIndex] || {}
      };
    } else {
      state.auditLogs[messageId] = { ...currentAuditLog, timeline: updatedTimeline };
    }
  },
  [fetchMessageAuditLogFailure.type]: (state, { payload: { messageId, isOnlyManual } }) => {
    const currentAuditLog = state.auditLogs[messageId];

    if (isOnlyManual) {
      state.auditLogs[messageId] = { ...currentAuditLog, tooltip: {} };
    }
  },
  [resetAllFilters.type]: state => {
    state.auditLogs = {};
  },
  [approveItemsSuccess.type]: cleanAuditLogOnMessageAction,
  [rejectItemsSuccess.type]: cleanAuditLogOnMessageAction
});

function cleanAuditLogOnMessageAction(state: State, { payload: { messageIds } }) {
  messageIds.forEach((messageId: string) => {
    const auditLog = state.auditLogs[messageId];

    if (auditLog) {
      state.auditLogs[messageId] = {};
    }
  });
}

function getStateName(stateName: string) {
  return stateName === 'blocked' ? 'rejected' : '';
}

export { auditReducer };
